<template>
  <!-- <div class="page">
    <div class="top-logo" @click="$gopage('index')">
      <img src="~images/logo-login.png">
      <span>朗朗书声</span>
    </div>
    <div class="container">
      <div class="cont">
        <div class="login-box">
          <div class="title">
            <h2>老师，请您注册</h2>
            <div class="tip">朗朗书声语文朗读教学平台（诵读资源库）</div>
          </div>
          <div class="form-box">
            <div class="form-item">
              <FInput ref="mobile" v-model="formData.mobile" :maxlength="11" type="text" placeholder="请输入手机号" />
            </div>
            <div class="form-item form-item-vcode">
              <div class="item-code">
                <FInput :showDel="false" v-model="formData.code" ref="code" :maxlength="6" type="text" placeholder="请输入6位短信验证码">
                  <button class="btn btn-code" :class="{disabled: !canSend}" v-text="btnText" @click="getCode"></button>
                </FInput>
              </div>
            </div>
            <div class="form-item mrb0">
              <FInput ref="pwd" v-model="formData.pwd" :maxlength="16" type="password" placeholder="设置您的密码（6-16位字母、数字、无空格）" />
            </div>
            <div class="form-item form-item-forget">
              <a class="forget" @click="$gopage('forget')">忘记密码</a>
            </div>
            <button class="btn btn-act" @click="submit" :class="{'btn-disabled': !isCanClick}">注册</button>
            <div class="reg-tip">
              已有账号？ 请&nbsp;<a @click="goLogin">登录</a>
            </div>
            <div class="private">
              注册即代表同意<a @click="$gopage('agreement')">《用户协议》</a>和<a @click="$gopage('privacy')">《隐私协议》</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="copy">Copyright @ 2020 朗朗书声 All Right Reserved 京ICP备19040061号</div>
      <div class="wj">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926" style="display:inline-block;">
          <img src="~images/icon-wj.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">京公网安备 11010502040926号</p>
        </a>
      </div>
    </div>
    <CodeValid ref="codeValid" @confirm="codeConfirm" v-model="showValidCode" />
  </div> -->
  <LoginModule>
    <div class="successBox flex-v" v-if="isRegiSuccess">
      <h2 class="title">教师注册</h2>
      <img src="~images/编组 37@2x(1).png" alt="" />
      <span class="toast">3s 后跳转至班级</span>
    </div>
    <template v-else>
      <div class="back flex" @click="goBack">
        <span class="iconfont fanhui1"></span>
        返回
      </div>
      <h2 class="title">教师注册</h2>
      <div class="contBox">
        <div class="item">
          <FInput
            class="ipt"
            ref="mobile"
            :maxlength="11"
            v-model="formData.mobile"
            type="text"
            placeholder="请输入手机号"
          />
        </div>
        <div class="item">
          <FInput
            class="ipt"
            ref="code"
            :maxlength="6"
            v-model="formData.code"
            type="text"
            placeholder="请输入验证码"
          >
            <button
              class="btn btn-code"
              :class="{ disabled: !canSend }"
              v-text="btnText"
              @click="getCode"
            ></button>
          </FInput>
        </div>
        <div class="item">
          <FInput
            class="ipt"
            ref="pwd"
            v-model="formData.pwd"
            :maxlength="16"
            type="password"
            placeholder="设置您的密码（6-16位字母、数字、无空格）"
          />
        </div>
        <button
          class="summit btn btn-act"
          @click="submit"
          :class="{ 'btn-disabled': !isCanClick }"
        >
          注册
        </button>
        <div class="reg-tip">已账号？ 请 <a @click="goLogin">登录</a></div>
        <div class="login-tip">
          注册既代表同意<a @click="$gopage('agreement')">《用户协议》</a>和<a
            target="_blank"
            @click="$gopage('privacy')"
            >《隐私协议》</a
          >
        </div>
      </div>
    </template>
    <CodeValid ref="codeValid" @confirm="codeConfirm" v-model="showValidCode" />
  </LoginModule>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import FInput from "base/input/index";
import CodeValid from "business/CodeValid";
import mixin_user from "mixin/user";
import Vue from "vue";
import md5 from "md5";
import LoginModule from "./loginModule.vue";

export default {
  components: {
    LoginModule,
    FInput,
    CodeValid,
  },
  mixins: [mixin_user],
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  data() {
    return {
      isCanClick: false,
      smsType: 1,
      formData: {
        mobile: "",
        code: "",
        pwd: "",
        captcha: "",
      },
      isRegiSuccess: false,
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        if (
          newVal.mobile &&
          newVal.code &&
          newVal.pwd &&
          newVal.pwd.length > 5
        ) {
          this.isCanClick = true;
        } else {
          this.isCanClick = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async submit() {
      if (!this.isCanClick) {
        return;
      }
      const formData = this.formData;
      if (!this.isCanClick) {
        return;
      }
      const config = [
        {
          id: "mobile",
          rule: {
            required: {
              message: "请输入手机号码",
            },
            mobile: {
              message: "请输入正确的手机号码",
            },
          },
        },
        {
          id: "code",
          rule: {
            required: {
              message: "请输入验证码",
            },
          },
        },
        {
          id: "pwd",
          rule: {
            required: {
              message: "请输入密码",
            },
            maxlength: {
              message: "密码长度不能大于16个字符",
              param(v) {
                return v.length <= 16;
              },
            },
            minlength: {
              message: "密码长度不能小于6个字符",
              param(v) {
                return v.length >= 6;
              },
            },
            char: {
              message: "请输入6-16位字母、数字、无空格",
              param(v) {
                return v && /^[a-zA-Z0-9]+$/.test(v);
              },
            },
          },
        },
      ];
      let { result } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      let query = this.$route.query;
      this.$loading.show();
      const params = {
        mobile: formData.mobile,
        code: formData.code,
        pwd: formData.pwd,
      };
      params.pwd = md5(params.pwd);
      const res = await this.$post("/passport/register.json", params);
      if (res.status == 200) {
        this.formData.mobile = "";
        this.formData.pwd = "";
        this.formData.code = "";
        this.$toast("账号注册成功!");
        if (res.data) {
          this.$store.dispatch("setUserInfo", res.data);
        }
        this.isRegiSuccess = true;
        setTimeout(() => {
          // this.$user.loginCallBack(query);
          this.goJumpNext();
        }, 3000);
      } else {
        this.$toast(res.message);
      }
      this.$loading.hide();
    },
  },
};
</script>
<style lang="less" scoped>
@import "~styles/user/index.less";

.successBox {
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  img {
    width: 224px;
    height: 153px;
    margin: 38px 0;
  }

  .toast {
    font-size: 16px;
    color: #666666;
  }
}

.contBox {
  .summit {
    margin-top: 10px;
  }
  .login-tip {
    margin-top: 0;
  }
}
</style>
